<template>
    <section ref="header" class="HeaderElement ContentSection ContentSection--hasclippath"
        :style="[{ 'background-color': pageData.color }, { height: getHeaderElementHeight(properties.image) }]">

        <div id="nav-bg" class="ContentSection ContentSection--hasclippath"
        :style="[{ 'background-color': pageData.color, 'opacity': topNavBgOpacity }]"></div>


        <Breadcrumbs v-if="properties.includeBreadcrumbs"></Breadcrumbs>

        <h1 v-html="properties.title"></h1>
        <div v-html="properties.subtitle"></div>
        <img v-if="properties.image" :src="getMediaPath(properties.image.src)" :alt="properties.image.name"
            :style="getImgProps">

    </section>
</template>
<script>
import Breadcrumbs from '../ui/Breadcrumbs.vue';

export default {
    props: ["properties", "pageData"],
    components: { Breadcrumbs },
    data() {
        return {
            topNavBgOpacity: 0,
            headerHeight: 0
        };
    },
    mounted() {
        this.headerHeight = this.$refs.header.clientHeight;
        window.addEventListener("scroll", this.onScroll);
    }, 
    methods: {
        getHeaderElementHeight(img) {
            return img !== null ? "560px" : "405px";
        },
        
        onScroll() {
            var scrollY = window.pageYOffset;
            if (scrollY < 5) {
                this.topNavBgOpacity = 0;
            } else if (scrollY < this.headerHeight - 100) {
                this.topNavBgOpacity = 0.8;
            } else {
                this.topNavBgOpacity = 1;
            }
        },

        getMediaPath(src) {
            return app.manifest.getMediaPath(src)
        }
    },
    computed: {
        getImgProps() {
            return {
                "margin-left": `${this.properties.imageXPosition}px`,
                "margin-top": `${this.properties.imageYPosition}px`,
                width: `${this.properties.imageWidth}`,
                height: `${this.properties.imageHeight}`
            };
        }
    },
    unmounted() {
        window.removeEventListener("scroll", this.onScroll);
    }
};
</script>
<style lang="scss">
@import '@/assets/sass/_responsiveness.scss';



.HeaderElement {
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
    // height: 560px;
    color: #fff;
    padding-top: 120px;
    padding-bottom: 80px;
    text-align: left;

    h1 {
        margin-bottom: 30px;
        z-index: 2;
    }

    &>div {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-direction: column;
        width: 100%;
        z-index: 2;
    }

    img {
        position: absolute;
        transform: translateX(-50%) translateY(-50%);
        top: 50%;
        left: 50%;
        pointer-events: none;
    }

}

#nav-bg {
    position: fixed;
    width: 100%;
    height: 75px;
    z-index: 3;
    transition: opacity .7s;
    display: none;
    top:0;

    &::after {
        left: -23%;
    }
}

@include tablet-only {
    #nav-bg {
        height: 55px;
      display: block;
  }

}


@include mobile-only {
    .HeaderElement {
        height: auto !important;
        padding-bottom: 20px;
    }
    
    #nav-bg {
        height: 55px;
        display: block;
    }
}
</style>